import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface ICreateSupportMessageState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const CreateSupportMessageEmptyState: ICreateSupportMessageState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
